import { Button, Modal } from "@mui/material";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { NavLink } from "react-router-dom";
import {
  openInfoModalState
} from "../../../atoms/myShipments";

const InfoModal = () => {
  const [openInfoModal, setOpenInfoModal] = useRecoilState(openInfoModalState)
  const handleClose = () => {
    setOpenInfoModal(false);
  };
  const handleOpen = () => {
    setOpenInfoModal(true);
  };

  return (
    <Modal
      open={openInfoModal}
      onClose={handleClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        zIndex: 9999,
        outline: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          maxWidth: "690px",
          width: "100%",
          overflow: "auto",
          borderRadius: "var(--wrapperBorderRadius)",
          outline: "none",
          maxHeight: "90vh",
        }}
      >
        <figure
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "var(--pastelBlue)",
          }}
        >
          <img
            src="/images/heros/heros.png"
            alt="Hadenka"
            style={{ maxWidth: "350px", width: "100%" }}
          />
        </figure>
        <div
          style={{ padding: "10px", display: "flex", flexDirection: "column", gap: "var(--gap)" }}
        >
          <h2
            style={{
              fontSize: "24px",
              lineHeight: "24px",
              color: "var(--btnBgBlue)",
              maxWidth: "400px",
              width: "100%",
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            ŞİFRENİZİ SIFIRLAMAYI UNUTMAYIN!
          </h2>
          <h6 style={{ fontSize: "16px", color: "var(--text)", textAlign: "center" }}>
            Değerli Üyemiz;
          </h6>
          <p style={{ fontSize: "14px", color: "var(--text)", textAlign: "center" }}>
            Ödeme altyapısındaki geliştirme dolayısıyla kısa süreli ödeme yapılamamaktadır. Anlayışınız için teşekkür ederiz.
          </p>
          <Button className="iyzi-button-blue" onClick={handleClose}>
            Tamam
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InfoModal;
